// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
}

.GiveAccess_container__6KmGr {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
}

.GiveAccess_header__IskWu {
  padding: 12px;
  background-color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-bottom: 1px solid #ddd;
}

.GiveAccess_searchInput__dEFZ7 {
  flex: 1 1 100%;
  max-width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.GiveAccess_routeWrapper__oc0mm {
  flex: 1 1;
  display: flex;
  align-items: center;
  position: relative;
}

.GiveAccess_navBtn__g5bln {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
}

.GiveAccess_left__iu8D3 {
  position: absolute;
  left: 0;
  z-index: 1;
}

.GiveAccess_right__9umLV {
  position: absolute;
  right: 0;
  z-index: 1;
}

.GiveAccess_sliderOuter__89O24 {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.GiveAccess_slider__qhvmj {
  display: flex;
  transition: transform 0.3s ease;
  will-change: transform;
  height: 100%;
}

.GiveAccess_cardWrapper__AIykY {
  /* пусть ширина будет по содержимому + отступы */
  min-width: 100%;
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  /* если нужно центрировать карточку внутри */
  display: flex;
  justify-content: center;
}

.GiveAccess_card__BeaRq {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  width: 100%;
  height: 90%;
  min-height: 100px;
  max-width: 400px;
  margin: auto;
}

.GiveAccess_newBadge__HfnuW {
  border: 2px solid #ff9800;
}

.GiveAccess_badge__5Qr5- {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: #ff9800;
  color: #ffffff;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}

.GiveAccess_title__Jd6UT {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.GiveAccess_cardContent__ray8o p {
  margin: 4px 0;
  font-size: 14px;
  color: #555;
}

/* Контейнер: фон — синий */
.GiveAccess_progressContainer__dNiRw {
  position: relative;
  width: 100%;
  height: 8px;
  background-color: #007bff; /* синий фон */
  border-radius: 4px;
  overflow: hidden;
}

/* Левый сегмент (доставлено) — зелёный, от левого края */
.GiveAccess_progressDelivered__dzedT {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #28a745; /* зелёный */
}

/* Средний сегмент (в процессе) не нужен, т.к. фон синий */

/* Правый сегмент (не доставлено) — красный, от правого края */
.GiveAccess_progressUndelivered__ZvFTv {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background-color: #dc3545; /* красный */
}

.GiveAccess_userListMobile__JXgZF {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 8px 0;
  padding: 0;         /* убираем отступы */
  list-style: none;   /* отключаем точки */
}

.GiveAccess_userItemMobile__tWojs {
  background-color: #f0f4f8;
  color: #333;
  font-size: 13px;
  padding: 6px 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.GiveAccess_userItemMobile__tWojs:hover {
  background-color: #d0e2f2;
}

.GiveAccess_userItemMobile__tWojs.GiveAccess_revoking__g31JQ {
  background-color: #fdecea;
  color: #b71c1c;
}




.GiveAccess_actions__XLyrZ {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.GiveAccess_openBtn__Ew\\+7y {
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  background-color: #4caf50;
  color: #ffffff;
  transition: background-color 0.3s ease;
}

.GiveAccess_openBtn__Ew\\+7y:hover {
  background-color: #43a047;
}

.GiveAccess_openedBtn__qR1Yp {
  background-color: #cccccc;
  color: #666666;
  cursor: default;
}

.GiveAccess_accessButtonsWrapper__fAqrS {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.GiveAccess_openBtn__Ew\\+7y,
.GiveAccess_accessBtn__uNI9j {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.GiveAccess_accessBtn__uNI9j {
  background-color: #1976d2;
  color: #ffffff;
}

.GiveAccess_accessBtn__uNI9j:hover {
  background-color: #1565c0;
}

.GiveAccess_empty__fUOcY {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #777;
}

/* DateRangePicker.module.css */
.GiveAccess_field__lF6Rd {
  display: flex;
  align-items: center;
  gap: 4px;         /* чуть меньше, чем раньше */
}

.GiveAccess_inputDate__51zJ8 {
  padding: 6px 8px;      /* компактнее */
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 12px;       /* мелче текст */
  background-color: #fafafa;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  width: 120px;          /* уже */
  min-width: 100px;      /* не слишком уж сужать */
}

.GiveAccess_inputDate__51zJ8:focus {
  outline: none;
  border-color: #66afe9;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/GiveAccess/GiveAccess.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4CAA4C;EAC5C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB,EAAE,cAAc;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,yBAAyB,EAAE,YAAY;AACzC;;AAEA,0DAA0D;;AAE1D,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,yBAAyB,EAAE,YAAY;AACzC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,UAAU,UAAU,oBAAoB;EACxC,gBAAgB,IAAI,oBAAoB;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;;;AAKA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,UAAU,4BAA4B;AAChD;;AAEA;EACE,gBAAgB,OAAO,eAAe;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe,QAAQ,gBAAgB;EACvC,yBAAyB;EACzB,kCAAkC;EAClC,sBAAsB;EACtB,YAAY,WAAW,QAAQ;EAC/B,gBAAgB,OAAO,yBAAyB;AAClD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[":global(body) {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.header {\r\n  padding: 12px;\r\n  background-color: #ffffff;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.searchInput {\r\n  flex: 1 1 100%;\r\n  max-width: 100%;\r\n  padding: 8px 12px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n}\r\n\r\n.routeWrapper {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.navBtn {\r\n  background: none;\r\n  border: none;\r\n  padding: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.left {\r\n  position: absolute;\r\n  left: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.right {\r\n  position: absolute;\r\n  right: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.sliderOuter {\r\n  overflow: hidden;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.slider {\r\n  display: flex;\r\n  transition: transform 0.3s ease;\r\n  will-change: transform;\r\n  height: 100%;\r\n}\r\n\r\n.cardWrapper {\r\n  /* пусть ширина будет по содержимому + отступы */\r\n  min-width: 100%;\r\n  padding: 16px;\r\n  box-sizing: border-box;\r\n  height: 100%;\r\n  /* если нужно центрировать карточку внутри */\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.card {\r\n  background-color: #ffffff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\r\n  padding: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 90%;\r\n  min-height: 100px;\r\n  max-width: 400px;\r\n  margin: auto;\r\n}\r\n\r\n.newBadge {\r\n  border: 2px solid #ff9800;\r\n}\r\n\r\n.badge {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  background-color: #ff9800;\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.title {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: #333;\r\n}\r\n\r\n.cardContent p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n/* Контейнер: фон — синий */\r\n.progressContainer {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 8px;\r\n  background-color: #007bff; /* синий фон */\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Левый сегмент (доставлено) — зелёный, от левого края */\r\n.progressDelivered {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  background-color: #28a745; /* зелёный */\r\n}\r\n\r\n/* Средний сегмент (в процессе) не нужен, т.к. фон синий */\r\n\r\n/* Правый сегмент (не доставлено) — красный, от правого края */\r\n.progressUndelivered {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  height: 100%;\r\n  background-color: #dc3545; /* красный */\r\n}\r\n\r\n.userListMobile {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  margin: 8px 0;\r\n  padding: 0;         /* убираем отступы */\r\n  list-style: none;   /* отключаем точки */\r\n}\r\n\r\n.userItemMobile {\r\n  background-color: #f0f4f8;\r\n  color: #333;\r\n  font-size: 13px;\r\n  padding: 6px 10px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.userItemMobile:hover {\r\n  background-color: #d0e2f2;\r\n}\r\n\r\n.userItemMobile.revoking {\r\n  background-color: #fdecea;\r\n  color: #b71c1c;\r\n}\r\n\r\n\r\n\r\n\r\n.actions {\r\n  margin-top: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.openBtn {\r\n  padding: 10px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  background-color: #4caf50;\r\n  color: #ffffff;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.openBtn:hover {\r\n  background-color: #43a047;\r\n}\r\n\r\n.openedBtn {\r\n  background-color: #cccccc;\r\n  color: #666666;\r\n  cursor: default;\r\n}\r\n\r\n.accessButtonsWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.openBtn,\r\n.accessBtn {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 10px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.accessBtn {\r\n  background-color: #1976d2;\r\n  color: #ffffff;\r\n}\r\n\r\n.accessBtn:hover {\r\n  background-color: #1565c0;\r\n}\r\n\r\n.empty {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 16px;\r\n  color: #777;\r\n}\r\n\r\n/* DateRangePicker.module.css */\r\n.field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;         /* чуть меньше, чем раньше */\r\n}\r\n\r\n.inputDate {\r\n  padding: 6px 8px;      /* компактнее */\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  font-size: 12px;       /* мелче текст */\r\n  background-color: #fafafa;\r\n  transition: border-color 0.2s ease;\r\n  box-sizing: border-box;\r\n  width: 120px;          /* уже */\r\n  min-width: 100px;      /* не слишком уж сужать */\r\n}\r\n\r\n.inputDate:focus {\r\n  outline: none;\r\n  border-color: #66afe9;\r\n  background-color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GiveAccess_container__6KmGr`,
	"header": `GiveAccess_header__IskWu`,
	"searchInput": `GiveAccess_searchInput__dEFZ7`,
	"routeWrapper": `GiveAccess_routeWrapper__oc0mm`,
	"navBtn": `GiveAccess_navBtn__g5bln`,
	"left": `GiveAccess_left__iu8D3`,
	"right": `GiveAccess_right__9umLV`,
	"sliderOuter": `GiveAccess_sliderOuter__89O24`,
	"slider": `GiveAccess_slider__qhvmj`,
	"cardWrapper": `GiveAccess_cardWrapper__AIykY`,
	"card": `GiveAccess_card__BeaRq`,
	"newBadge": `GiveAccess_newBadge__HfnuW`,
	"badge": `GiveAccess_badge__5Qr5-`,
	"title": `GiveAccess_title__Jd6UT`,
	"cardContent": `GiveAccess_cardContent__ray8o`,
	"progressContainer": `GiveAccess_progressContainer__dNiRw`,
	"progressDelivered": `GiveAccess_progressDelivered__dzedT`,
	"progressUndelivered": `GiveAccess_progressUndelivered__ZvFTv`,
	"userListMobile": `GiveAccess_userListMobile__JXgZF`,
	"userItemMobile": `GiveAccess_userItemMobile__tWojs`,
	"revoking": `GiveAccess_revoking__g31JQ`,
	"actions": `GiveAccess_actions__XLyrZ`,
	"openBtn": `GiveAccess_openBtn__Ew+7y`,
	"openedBtn": `GiveAccess_openedBtn__qR1Yp`,
	"accessButtonsWrapper": `GiveAccess_accessButtonsWrapper__fAqrS`,
	"accessBtn": `GiveAccess_accessBtn__uNI9j`,
	"empty": `GiveAccess_empty__fUOcY`,
	"field": `GiveAccess_field__lF6Rd`,
	"inputDate": `GiveAccess_inputDate__51zJ8`
};
export default ___CSS_LOADER_EXPORT___;
